<p-scrollTop [threshold]="100" icon="pi pi-arrow-up-white"></p-scrollTop>
<p-toast
  [key]="toastWidgetKey"
  position="top-right"
  [preventOpenDuplicates]="true"
  class="cfc-toast"
>
  <ng-template let-message pTemplate="message">
    <span
      [class]="
        'p-toast-message-icon pi' + (message.icon ? ' ' + message.icon : '')
      "
      [ngClass]="{
        'pi-info-circle': message.severity == 'info',
        'pi-exclamation-triangle': message.severity == 'warn',
        'pi-times-circle': message.severity == 'error',
        'pi-check': message.severity == 'success'
      }"
    ></span>
    <div class="p-toast-message-text">
      <div class="p-toast-summary">{{ message.summary | translate }}</div>
      <div class="p-toast-detail">
        <div *ngIf="message.data">
          <ng-container [ngSwitch]="message.data.toastType">
            <ng-container *ngSwitchCase="'process'">
              {{ 'Next Processor' | translate }} {{ message.data.userNo }}
              {{ message.data.userName }}
            </ng-container>
            <ng-container *ngSwitchCase="'processMultiple'">
              {{ 'Next Processor Pool:' | translate }}
              <div *ngFor="let user of message.data.userInfos; index as i">
                <ng-container *ngIf="i < 5"
                  >{{ user.userNo }} {{ user.userName }}</ng-container
                >
              </div>
              <div *ngIf="message.data.userInfos.length > 5">...</div>
            </ng-container>
            <ng-container *ngSwitchDefault></ng-container>
          </ng-container>
        </div>
        <div>{{ message.detail | translate }}</div>
      </div>
    </div>
  </ng-template>
</p-toast>
